module.exports = __webpack_public_path__ + "img/contact3.95a33154.svg";